type Props = {
  className?: string;
};

const ErrorOutline = ({ className = '' }: Props) => (
  <svg
    focusable={false}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='25'
    viewBox='0 0 24 25'
  >
    <path
      fill='#000'
      fillRule='nonzero'
      d='M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5zM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm.75 11a.75.75 0 1 1-1.5 0V7a.75.75 0 1 1 1.5 0v6zM12 16.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z'
    />
  </svg>
);

export default ErrorOutline;
